<template>
  <!-- Modal d'ajout à la liste de favoris -->
  <UModal v-model:open="isOpen">
    <!-- Bouton d’ouverture dans le slot par défaut -->
    <UButton
      icon="djust-icon:heart-white"
      variant="solid"
      color="primary"
      size="md"
      :ui="uiProps"
      class="dj-add-to-bl-btn flex flex-row items-center justify-center"
      :disabled="!props.isAuthenticated || isAdding"
      :loading="isAdding"
      @click.stop.prevent="isOpen = true"
    />

    <!-- Contenu du modal -->
    <template #content>
      <DjAddProductForm
        :title="t('DjAddToBuyingListButton.addFavoris')"
        icon="djust-icon:heart-white"
        :select-text="$t('DjAddToBuyingListButton.selectList')"
        :select-placeholder="$t('DjAddToBuyingListButton.placeholder')"
        :create-text="$t('DjAddToBuyingListButton.createList')"
        :input-placeholder="$t('DjAddToBuyingListButton.namePlaceholder')"
        :options="buyingLists || []"
        @close="isOpen = false"
        @select="selectBuyingList"
        @submit="(name: string) => handleBuyingList(name, selected)"
      />
    </template>
  </UModal>
</template>

<script setup lang="ts">
  import type { UpdateCartLineType } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/cart';

  interface DjAddToBuyingListProps {
    typeId: string;
    lines: Array<{
      variantId?: string;
      offerPriceId?: string;
      quantity: number;
      updateAction: UpdateCartLineType;
    }>;
    isAuthenticated: boolean;
    ui?: object;
  }

  const props = defineProps<DjAddToBuyingListProps>();
  const emit = defineEmits(['added', 'error']);
  const uiProps = props.ui ?? { base: 'p-2 rounded-sm' };
  const { addOrUpdateBuyingList } = useBuyingList();
  const buyingListStore = useBuyingListStore();
  const { getUserCurrency } = useUser();
  const { t } = useI18n();

  const isOpen = ref(false);
  const isAdding = ref(false);
  const selected = ref('');
  const currency = computed(() => getUserCurrency());
  const buyingLists = computed(() => buyingListStore.buyinglist);

  const selectBuyingList = (selectedId: string) => (selected.value = selectedId);

  const handleBuyingList = async (name: string, selectedId: string) => {
    if (!props.isAuthenticated) return;

    try {
      isAdding.value = true;

      const response = await addOrUpdateBuyingList({
        currency: currency.value,
        actionType: name ? 'create' : 'update',
        buyingListId: selectedId,
        typeId: props.typeId,
        name,
        lines: props.lines,
      });

      emit('added', response?.newBuyingList);
      isOpen.value = false;
    } catch (error) {
      emit('error', error);
      isOpen.value = false;
    } finally {
      isAdding.value = false;
    }
  };
</script>

<style lang="scss" scoped>
  @use './DjAddToBuyingListButton.scss';
</style>
